<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{$t('admin.views.materials.add')}}
      </template>
    </AdminStickyHeader>
    <Form />
  </div>
</template>

<script>
import Form from "./Form";
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
export default {
  name: "Add",
  components: { AdminStickyHeader, Form },
};
</script>
